export const SUPPORTED_LOCALES = [
  'en',
  'es',
  'ca',
  'fr',
  'it',
  'de',
  'pt',
  'bg',
  'da',
  'el',
  'ru',
  'zh',
  'ja',
  'ar',
  'hi',
];

function readCookie(name) {
  if (typeof document === 'undefined') return null;

  const escapedName = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  const regex = new RegExp(`(?:^|; )${escapedName}=([^;]*)`);
  const match = document.cookie.match(regex);

  return match ? decodeURIComponent(match[1]) : null;
}

export function getInitialLocale() {
  const fromCookie = readCookie('i18n_redirected');
  if (fromCookie && SUPPORTED_LOCALES.includes(fromCookie)) {
    return fromCookie;
  }

  if (typeof navigator !== 'undefined' && navigator.language) {
    const browserLang = navigator.language.split('-')[0];
    if (SUPPORTED_LOCALES.includes(browserLang)) {
      return browserLang;
    }
  }
  return 'es';
}

export default getInitialLocale;


